var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"app-header"},[_c('router-link',{style:({
      visibility: _vm.admin ? 'visible' : 'hidden',
    }),attrs:{"to":{ name: 'Menu' }}},[_vm._v("Menu")]),_vm._v(" "),(_vm.loggedIn)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.logoutClicked}},[_vm._v("Logout")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dca7112","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = null
// module chunks = 